import { getSaldosEdificios } from "./getSaldoEdificio";

// Comisiones de edificios se liquidan trimestralmente: enero, abril, julio, octubre.
// Día 15 como referencia. Si hoy ya pasó día 15 del mes en curso de pago, devuelve el siguiente.
const proximaFechaPago = () => {
  const hoy = new Date();
  const mesesPago = [1, 4, 7, 10];
  for (let i = 0; i < 14; i++) {
    const candidato = new Date(hoy.getFullYear(), hoy.getMonth() + i, 15);
    if (mesesPago.includes(candidato.getMonth() + 1) && candidato >= hoy) {
      // AJUSTE TEMPORAL (2026-07): los contratos de edificios están pendientes de firma, así que
      // la liquidación trimestral se posterga UN trimestre (Q siguiente al siguiente): p.ej. cierra
      // Q2 → paga 15/10 en vez de 15/07. Se corre +3 meses el próximo día de liquidación.
      // REVERTIR (quitar este setMonth(+3)) cuando exista la herramienta de "pago condicionado a
      // contrato firmado".
      candidato.setMonth(candidato.getMonth() + 3);
      return candidato.toISOString().split("T")[0];
    }
  }
  return `${hoy.getFullYear() + 1}-01-15`;
};

/**
 * Wrapper delgado sobre getSaldosEdificios (fuente única de verdad). Devuelve los edificios con saldo
 * pendiente > 0 con el shape que consumen el modal "Pago a edificio" y el tab Edificios de FlujoCajaV2.
 *
 * saldoPendiente = saldo = recaudada − pagada (acumulado [2023-01-01 … hoy]). Antes este util calculaba
 * "generada del último trimestre desde FECHA_CORTE", lo que divergía del EECC; ahora comparten motor.
 * Los params fechaInicio/monedaLocal se mantienen por compatibilidad de firma (ya no truncan el rango).
 */
export const getEdificiosSaldoPendiente = async ({ pais, monedaLocal }) => {
  const saldos = await getSaldosEdificios({ pais });
  const proxFecha = proximaFechaPago();

  return saldos
    .filter((e) => e.saldo > 0)
    .map((e) => ({
      edificioId: Number(e.edificioId),
      edificioNombre: e.edificioNombre,
      debitoTotal: e.recaudada,
      creditoTotal: e.pagada,
      saldoPendiente: e.saldo,
      moneda: e.moneda || monedaLocal,
      proximaFecha: proxFecha,
    }))
    .sort((a, b) => b.saldoPendiente - a.saldoPendiente);
};
